import UploadPhotosView from './UploadPhotos.view';
export default {
    title: 'Pages/copyright-checker/aanmaken',
    component: UploadPhotosView,
    parameters: {
        padding: 0,
    },
};
export const Default = {
    args: {},
};
